// Centralized site content – easy to tweak
export const SITE = {
  name: "Infini10 Technologies",
  short: "Infini10",
  tagline: "Infinite Vision · 10X Execution",
  phone: "+91 91102 48636",
  phoneRaw: "+919110248636",
  email: "admin@infini10technologies.com",
  address:
    "38, 1st Floor, Maruthi Nilaya, 1st Cross, 1st Main, MutturayaSwamy Layout, Hulimavu, Begur, Bangalore - 560076, Karnataka",
  city: "Bangalore",
  founded: 2014,
  verifyProUrl: "https://verifypro.infini10technologies.com/",
  socials: {
    linkedin: "#",
    twitter: "#",
    instagram: "#",
  },
};

export const SERVICES = [
  {
    slug: "background-verification",
    title: "Background Verification",
    eyebrow: "01 / Our Flagship Practice",
    flagship: true,
    short:
      "Hire with absolute confidence — India's most comprehensive, audit-grade background-verification programme.",
    long:
      "Background Verification is the heart of what we do at Infini10. We run end-to-end pre-employment screening and ongoing employee verification programmes for some of India's most demanding compliance teams — covering identity, education, employment, address, criminal, court, database, drug, reference and credit checks. Every report is delivered through a single secure dashboard with tamper-evident audit trails, evidentiary documents and clear adjudication.",
    bullets: [
      "Identity, address & criminal court checks",
      "Education & employment verification",
      "Reference checks & database screens",
      "Drug, credit & global watchlist screening",
    ],
    image:
      "https://images.unsplash.com/photo-1589330694653-ded6df03f754?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxkb2N1bWVudCUyMHNlY3VyaXR5JTIwdmVyaWZpY2F0aW9uJTIwYnVzaW5lc3N8ZW58MHx8fHwxNzgwOTM4NjkwfDA&ixlib=rb-4.1.0&q=85",
    icon: "ShieldCheck",
  },
  {
    slug: "recruitment",
    title: "Recruitment",
    eyebrow: "02 / Talent Acquisition",
    short: "End-to-end hiring for permanent, contract and contract-to-hire roles.",
    long: "We orchestrate hiring programs that scale — from a single niche specialist to entire engineering pods. Our consultants partner with your hiring managers to write sharper role-charters, run structured interviews and close offers faster, without burning candidate goodwill.",
    bullets: [
      "Permanent, contract & C2H placements",
      "Executive search for leadership roles",
      "Bulk hiring for ramp-ups and migrations",
      "Industry-mapped sourcing across India",
    ],
    image:
      "https://images.unsplash.com/photo-1690378820474-b468b8ee64d3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBkaXZlcnNlJTIwb2ZmaWNlJTIwcHJvZmVzc2lvbmFscyUyMHRlYW13b3JrfGVufDB8fHx8MTc4MDkzODY5MHww&ixlib=rb-4.1.0&q=85",
    icon: "Users",
  },
  {
    slug: "it-operations",
    title: "IT Operations",
    eyebrow: "03 / Run & Optimise",
    short: "Managed IT operations — keep the lights on while you build the future.",
    long: "From service-desk uplifts to cloud migrations and 24×7 NOC support, we field experienced operations teams who treat your infrastructure like their own. Predictable SLAs, transparent reporting and a relentless focus on mean-time-to-resolution.",
    bullets: [
      "L1/L2/L3 service desk & NOC",
      "Cloud, DevOps & SRE engineering",
      "Application maintenance & support",
      "Vendor & ITSM transformation",
    ],
    image:
      "https://images.unsplash.com/photo-1762163516269-3c143e04175c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxJVCUyMHNlcnZlciUyMHJvb20lMjBuZXR3b3JrJTIwZW5naW5lZXJ8ZW58MHx8fHwxNzgwOTM4Njg5fDA&ixlib=rb-4.1.0&q=85",
    icon: "Cpu",
  },
  {
    slug: "it-professionals",
    title: "IT Professionals",
    eyebrow: "04 / Specialist Networks",
    short: "A curated bench of engineers, architects and product specialists.",
    long: "Tap into a pre-vetted bench of mid-to-senior IT professionals across cloud, data, full-stack, cybersecurity and emerging-tech stacks. Whether you need a sprint-ready contractor next week or a full pod for the next 18 months, we have the people.",
    bullets: [
      "Full-stack, Cloud, Data & AI engineers",
      "Solution & enterprise architects",
      "Cybersecurity & GRC specialists",
      "Product, UX & QA specialists",
    ],
    image:
      "https://images.unsplash.com/photo-1506399309177-3b43e99fead2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwyfHxJVCUyMHNlcnZlciUyMHJvb20lMjBuZXR3b3JrJTIwZW5naW5lZXJ8ZW58MHx8fHwxNzgwOTM4Njg5fDA&ixlib=rb-4.1.0&q=85",
    icon: "CodeSimple",
  },
];

export const BGV_CHECK_CATEGORIES = [
  {
    title: "Identity",
    icon: "IdentificationCard",
    items: ["PAN verification", "Aadhaar (UIDAI) check", "Passport authentication", "Voter ID & Driving License"],
  },
  {
    title: "Address",
    icon: "MapPin",
    items: ["Current address (physical)", "Permanent address (postal/physical)", "Cohabitant verification", "Address history (up to 7 years)"],
  },
  {
    title: "Education",
    icon: "GraduationCap",
    items: ["Degree authenticity (UGC/AICTE)", "Marksheet & transcript checks", "Direct institute confirmation", "International degree verification (WES)"],
  },
  {
    title: "Employment",
    icon: "Briefcase",
    items: ["Past employer confirmation", "Tenure, designation & exit reasons", "Salary & relieving letter checks", "EPFO / UAN trace"],
  },
  {
    title: "Criminal & Court",
    icon: "Scales",
    items: ["Civil & criminal court records", "District-level court check", "CIBIL writ history", "Police verification (where applicable)"],
  },
  {
    title: "Reference",
    icon: "ChatsCircle",
    items: ["Structured manager references", "Peer & subordinate feedback", "Cultural-fit screening", "Confidential 360° calls"],
  },
  {
    title: "Database & Watchlist",
    icon: "ShieldStar",
    items: ["Global sanctions & PEP screening", "OFAC, UN, EU watchlists", "Industry blacklists & defaulter lists", "Social-media red-flag screening"],
  },
  {
    title: "Drug & Health",
    icon: "TestTube",
    items: ["5-panel drug screening", "10-panel drug screening", "Fitness-for-work certificates", "NABL-accredited lab partners"],
  },
  {
    title: "Credit & Financial",
    icon: "CreditCard",
    items: ["CIBIL / Experian credit checks", "Bankruptcy & litigation history", "Director / DIN verification", "Conflict of interest screening"],
  },
];

export const BGV_PROCESS = [
  {
    step: "01",
    title: "Initiate",
    desc: "You raise a case in our portal or via API. Bulk uploads, custom case-types and white-label flows are supported out of the box.",
  },
  {
    step: "02",
    title: "Consent",
    desc: "Candidates receive a branded, mobile-first consent link that captures e-signature, PII and supporting documents in one secure flow.",
  },
  {
    step: "03",
    title: "Verify",
    desc: "Our analysts run the checks in parallel — direct institute calls, registered post, court searches, NABL labs and authenticated database lookups.",
  },
  {
    step: "04",
    title: "Adjudicate",
    desc: "Every discrepancy is graded (Major / Moderate / Minor / Insufficient) with documentary evidence so your team can decide in seconds.",
  },
  {
    step: "05",
    title: "Report",
    desc: "Tamper-evident PDF and dashboard report delivered with full audit trail, source documents and an executive summary.",
  },
  {
    step: "06",
    title: "Re-verify",
    desc: "Optional ongoing screens — annual re-verification, post-event triggers and watchlist monitoring for sensitive roles.",
  },
];

export const BGV_WHY = [
  {
    title: "Audit-grade evidence",
    desc: "Every claim in a Infini10 report is backed by source documents — institute letters, employer emails, court order sheets — none of it generated, all of it preserved.",
    icon: "ShieldCheck",
  },
  {
    title: "Fast turnarounds",
    desc: "Median TAT of 5 working days for the standard pack; 48 hours for fast-track identity + database checks. Live SLA monitoring in your dashboard.",
    icon: "Lightning",
  },
  {
    title: "Compliance built-in",
    desc: "Aligned with NASSCOM NSR, SHRM, ISO 27001 and India's DPDP Act 2023. Data residency, retention and consent — handled.",
    icon: "Certificate",
  },
  {
    title: "Pan-India coverage",
    desc: "On-ground field associates in 740+ districts across India, plus international coverage for education and employment in 60+ countries.",
    icon: "GlobeHemisphereEast",
  },
  {
    title: "API & ATS-native",
    desc: "Plug-and-play integrations with leading ATS, HRMS and onboarding platforms.",
    icon: "Plug",
  },
  {
    title: "Human-in-the-loop",
    desc: "Every report is reviewed by a senior analyst before release. We don't ship robot reports — we ship hiring decisions you can defend.",
    icon: "UserCheck",
  },
];

export const BGV_INDUSTRIES = [
  "IT & Tech Services",
  "Banking, Financial Services & Insurance",
  "Healthcare & Pharma",
  "Retail & E-commerce",
  "Logistics & Mobility",
  "Manufacturing & GCCs",
  "Education & EdTech",
  "Government & PSUs",
];

export const BGV_PACKAGES = [
  {
    name: "Essentials",
    tag: "Mass hiring · entry-level",
    blurb: "The fastest, lightest pack — perfect for high-volume hiring where speed wins.",
    items: ["Identity", "Address (postal)", "Database / Watchlist", "Education (highest)"],
  },
  {
    name: "Standard",
    tag: "Most popular · mid-level",
    blurb: "Our most-deployed pack covering 92% of typical IT/BFSI requirements.",
    items: ["Identity", "Address (physical)", "Education (all)", "Employment (last 2)", "Criminal court", "Database"],
    featured: true,
  },
  {
    name: "Executive",
    tag: "Leadership · sensitive roles",
    blurb: "Deep-dive screening for CXO, finance, infosec and customer-facing leadership roles.",
    items: ["All Standard checks", "Reference (360°)", "Credit / CIBIL", "Civil court", "Directorship", "Media & sanctions"],
  },
];

export const PRODUCTS = [
  {
    slug: "verifypro",
    name: "VerifyPro",
    tagline: "Background verification that answers to you",
    status: "live",
    color: "#fe4c1c",
    letter: "V",
    short:
      "An AI-powered, multi-tenant BGV platform built for Indian enterprises and BFSI — from candidate self check-in to CXO-level command, all on one console. DPDP Act 2023 compliant by design.",
    features: [
      "Multimodal Executive Agent (voice + gesture)",
      "AI-powered CXO dashboards & topology map",
      "Live field-agent tracking on Google Maps",
      "Self check-in · Aadhaar eKYC · PAN · DigiLocker",
      "HRMS connectors · Multi-tenant · Masked storage",
    ],
    href: "https://verifypro.infini10technologies.com/",
  },
  {
    slug: "opsdesk",
    name: "OpsDesk",
    tagline: "IT Ops & Service Desk",
    status: "coming-soon",
    color: "#8b5cf6",
    letter: "O",
    short:
      "Modern ITSM for lean IT teams. Tickets, incidents, SLAs and change management — without the enterprise-suite bloat.",
    features: [
      "Multi-channel ticket intake",
      "SLA policies & escalations",
      "Change & release workflow",
      "Native chat platform integrations",
    ],
    href: null,
  },
];

export const VERIFYPRO_CONNECTORS = [
  {
    name: "Zoho People",
    type: "HRMS",
    color: "#e42527",
    letter: "ZP",
    desc: "Auto-trigger BGV cases when a new hire is added. Push status updates back to the employee record in real time.",
  },
  {
    name: "Zoho Recruit",
    type: "ATS",
    color: "#256cb2",
    letter: "ZR",
    desc: "Launch verification straight from the offer-accepted stage. Report links & risk scores sync to the candidate card.",
  },
  {
    name: "Keka",
    type: "HRMS",
    color: "#4c6ef5",
    letter: "K",
    desc: "One-click BGV from the Keka hiring pipeline. Automated status write-back and document attachment on close.",
  },
  {
    name: "DarwinBox",
    type: "HRMS",
    color: "#00b7ab",
    letter: "DB",
    desc: "Enterprise-grade integration for large HR teams. Bulk case creation, SSO, and consolidated audit exports.",
  },
];

export const VERIFYPRO_CAPABILITIES = [
  {
    title: "Multimodal Executive Agent",
    tag: "NEW · A First in BGV",
    icon: "MicrophoneStage",
    desc: "Say it. Wave it. See it verified. A voice- and hand-gesture-controlled virtual assistant inside the CXO & HR console. Wake it with a gesture, ask for insights out loud, and command your entire verification operation hands-free.",
    bullets: [
      "Voice + hand-gesture control",
      "Available in CXO & HR consoles only",
      "Opt-in, privacy-first — no recordings stored",
      "Instant natural-language answers on cases, TAT, discrepancies",
    ],
  },
  {
    title: "AI-Powered CXO Dashboards",
    tag: "Executive Insight",
    icon: "ChartLineUp",
    desc: "AI surfaces trends, risks and TAT insights for leadership. Boardroom-ready dashboards built for CHROs, CROs and CISOs — volume, discrepancy rates, geography splits and financial exposure, one screen, drill-anywhere. Insight generation only — every decision stays human.",
    bullets: [
      "AI-surfaced trends, risks & TAT insights",
      "Volume, discrepancy heat-maps & SLA breaches",
      "Financial exposure & geo-split analytics",
      "Scheduled PDF & email digests",
    ],
  },
  {
    title: "Live Case-Topology Map",
    tag: "Live Ops",
    icon: "TreeStructure",
    desc: "A living map of your verification pipeline — every case, check and bottleneck visible to CXO and HR in real time. Auto-alerts when a case stalls past SLA, drill into any node for full evidence.",
    bullets: [
      "Real-time state-graph per case",
      "Auto-alerts on SLA breaches",
      "Colour-coded severity & priority routing",
      "Drill into any node to see evidence",
    ],
  },
  {
    title: "Live Field-Agent Tracking",
    tag: "Ops Command",
    icon: "MapTrifold",
    desc: "Track field verifications on Google Maps and 'wake' agents with push tasks — dispatched manually or automatically. GPS breadcrumbs, geo-tagged evidence and ETA to next case.",
    bullets: [
      "Live agent location on Google Maps",
      "Push tasks — manual or auto-dispatch",
      "Geo-fenced address verification",
      "Photo + timestamp evidence per visit",
    ],
  },
  {
    title: "Self Check-in",
    tag: "Candidate Journey",
    icon: "UserCircleCheck",
    desc: "Candidates upload Aadhaar or PAN and VerifyPro extracts, verifies and emails the report — easy on both sides of the check. DigiLocker-backed, consent-first, mobile-first.",
    bullets: [
      "Aadhaar / PAN upload by candidate",
      "Auto-extraction & instant eKYC verification",
      "DigiLocker integration for authenticated docs",
      "Consent-first candidate flow",
    ],
  },
  {
    title: "Assisted Mode for BFSI",
    tag: "Branch Ready",
    icon: "Bank",
    desc: "Nearly 1 in 3 candidates need help finishing checks. Branch associates can now complete verification for walk-ins in minutes — perfect for BFSI onboarding and last-mile completion.",
    bullets: [
      "Branch-associate assisted flow",
      "Walk-in verification in minutes",
      "Ideal for BFSI onboarding",
      "Reduces drop-off on incomplete cases",
    ],
  },
  {
    title: "One-Console Orchestration",
    tag: "Unified Workspace",
    icon: "SquaresFour",
    desc: "Run the whole verification flow from a single dashboard — fewer tools, tighter visibility, faster turnaround. HRMS, digital checks, field agents, reports — all in one console.",
    bullets: [
      "End-to-end BGV in a single UI",
      "Multi-tenant SaaS for enterprises",
      "Masked data storage & role-based access",
      "DPDP Act 2023 · compliant by design",
    ],
  },
];

export const DIGITAL_CHECKS = [
  { name: "Aadhaar eKYC", letter: "A", color: "#f97316" },
  { name: "PAN", letter: "P", color: "#0ea5e9" },
  { name: "DigiLocker", letter: "DL", color: "#7c3aed" },
];

export const HOW_IT_WORKS = [
  {
    step: "01",
    title: "Sign up in minutes",
    desc: "Free trial. No credit card. Add your team, brand your candidate flow — done in ten minutes.",
  },
  {
    step: "02",
    title: "Configure your checks",
    desc: "Pick a template or compose a custom pack. Save it, clone it, reuse across roles.",
  },
  {
    step: "03",
    title: "Run & report",
    desc: "Invite candidates. Track cases live. Download audit-grade PDF reports the moment they close.",
  },
];

export const PRICING_TIERS = [
  {
    name: "Starter",
    price: "₹0",
    period: "14-day free trial",
    tag: "Try before you buy",
    blurb: "Everything you need to run your first ten cases — on us.",
    features: [
      "Up to 10 cases",
      "Identity + Address + Education",
      "Self-serve dashboard",
      "PDF reports & audit trail",
      "Email support",
    ],
    cta: "Start free trial",
  },
  {
    name: "Professional",
    price: "₹6,999",
    period: "/ month",
    tag: "Most popular",
    blurb: "For growing teams running 50+ verifications a month.",
    features: [
      "Up to 250 cases / month",
      "All 40+ check types",
      "Bulk uploads + REST API",
      "Team roles + SSO",
      "Webhooks & ATS integrations",
      "Priority chat support",
    ],
    featured: true,
    cta: "Start free trial",
  },
  {
    name: "Enterprise",
    price: "Custom",
    period: "annual contract",
    tag: "For scale",
    blurb: "Volume pricing, dedicated infra and white-glove onboarding.",
    features: [
      "Unlimited cases",
      "Custom SLAs & data residency",
      "Dedicated success manager",
      "White-labelled candidate flow",
      "Bespoke integrations",
      "24×7 phone support",
    ],
    cta: "Talk to sales",
  },
];

export const MANAGED_ADDONS = [
  {
    title: "Managed BGV Operations",
    desc: "Prefer hands-off? Our senior analysts run every case for you, adjudicate discrepancies and deliver signed reports.",
    icon: "ShieldStar",
  },
  {
    title: "Recruitment",
    desc: "Need candidates too? We source, screen and shortlist across IT, BFSI, healthcare and GCC roles.",
    icon: "Users",
  },
  {
    title: "IT Operations",
    desc: "L1/L2/L3 service desk, cloud & DevOps engineering, application maintenance — on demand.",
    icon: "Cpu",
  },
  {
    title: "IT Professionals",
    desc: "A curated bench of engineers, architects and specialists — contract, C2H or permanent.",
    icon: "CodeSimple",
  },
];

export const INTEGRATIONS = [
  "REST API", "Webhooks", "Single Sign-On", "Bulk CSV", "ATS partners", "HRMS partners", "Chat & Email", "Data warehouses",
];

export const CLIENT_LOGOS = [
  { name: "Client 1", img: "https://freshmindsservices.com/images/1.jpg" },
  { name: "Client 2", img: "https://freshmindsservices.com/images/2.jpg" },
  { name: "Client 3", img: "https://freshmindsservices.com/images/3.jpg" },
  { name: "Client 4", img: "https://freshmindsservices.com/images/4.jpg" },
  { name: "Client 5", img: "https://freshmindsservices.com/images/5.jpg" },
  { name: "Client 7", img: "https://freshmindsservices.com/images/7.jpg" },
  { name: "Client 8", img: "https://freshmindsservices.com/images/8.jpg" },
  { name: "Client 9", img: "https://freshmindsservices.com/images/9.jpg" },
];

export const STATS = [
  { value: "11+", label: "Years in business" },
  { value: "12k+", label: "Candidates placed" },
  { value: "180+", label: "Active clients" },
  { value: "48 hr", label: "Avg. first shortlist" },
];

export const BGV_STATS = [
  { value: "250k+", label: "Reports delivered" },
  { value: "5 days", label: "Median TAT" },
  { value: "740+", label: "Districts covered" },
  { value: "99.4%", label: "First-pass accuracy" },
];

export const TESTIMONIALS = [
  {
    quote:
      "Infini10 shortlisted four senior SREs in under a week — and three of them were on the floor by the end of the month. Rare to find a partner this fast and this exacting.",
    name: "Anita Krishnan",
    role: "VP, Engineering — Bangalore Fintech",
  },
  {
    quote:
      "Their background-verification reports are spotless. Clean audit trails, fast turnarounds and zero ambiguity. It is the most professional BGV experience our compliance team has had.",
    name: "Rohit Menon",
    role: "Head of People Operations — SaaS Co.",
  },
  {
    quote:
      "We outsourced our entire L2 service-desk to Infini10 last year. Tickets close faster, escalations dropped 40%, and our internal teams are happier.",
    name: "Sanjana Rao",
    role: "Director IT — Retail Group",
  },
];
